var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.292 0.0683594C8.62762 0.0683594 0.791992 8.12786 0.791992 18.0684C0.791992 28.0089 8.62762 36.0684 18.292 36.0684C27.9564 36.0684 35.792 28.0089 35.792 18.0684C35.792 8.12786 27.9564 0.0683594 18.292 0.0683594ZM15.4351 25.5684L8.87262 19.0899L10.907 16.9374L15.3987 21.3429L25.6376 10.5684L27.7114 12.6819L15.4351 25.5684Z",
    fill: "#15CF74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.bb1d95507d9c9f70f9d0747fdd7cee53.svg";
export { ForwardRef as ReactComponent };